/**
 * @author Hideo Yamada
 * @description https://marvelapp.com/prototype/1152g05j/screen/67851883
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import EditDropdown from '@components/EditDropdown';
import { CONNECTION_MOBILE_TABLIST } from '~/services/constants';
import People from './People';
import Companies from './Companies';
import ReceivedRequests from './ReceivedRequests';
import SentRequests from './SentRequests';

const Connections = ({ business }) => {
    const company = business.vrs;
    const connections = business.vrs?.connections;
    if (!connections) return null;

    const [active, setActive] = useState('people');

    return (
        <ErrorBoundary className="company-profile-connections card">
            <div className="connections-header p-2">
                <p className="dsl-b22 bold my-2">{`${company.name} Connections`}</p>
            </div>
            <ResponsiveTabs className="p-2" active={active} data={CONNECTION_MOBILE_TABLIST} onTab={(e) => setActive(e.id)} />
            <Tab eventKey="people" active={active}>
                <People connections={connections.active_user_connections} />
            </Tab>
            <Tab eventKey="companies" active={active}>
                <Companies connections={connections.active_company_connections} />
            </Tab>
            <Tab eventKey="received" active={active}>
                <ReceivedRequests company={company} connections={connections.pending_connections_received} />
            </Tab>
            <Tab eventKey="sent" active={active}>
                <SentRequests connections={connections.pending_connections_sent} />
            </Tab>
        </ErrorBoundary>
    );
};

Connections.propTypes = {
    business: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        vrs: PropTypes.shape({
            id: PropTypes.number,
            connections: PropTypes.shape({
                active_company_connections: PropTypes.array,
                active_user_connections: PropTypes.array,
                follower_companies: PropTypes.array,
                follower_users: PropTypes.array,
                following_companies: PropTypes.array,
                following_users: PropTypes.array,
                pending_connections_received: PropTypes.array,
                pending_connections_sent: PropTypes.array,
            }),
        }),
    }),
};

Connections.defaultProps = {
    business: {
        id: 0,
        name: '',
        vrs: {
            id: 0,
            connections: {
                active_company_connections: [],
                active_user_connections: [],
                follower_companies: [],
                follower_users: [],
                following_companies: [],
                following_users: [],
                pending_connections_received: [],
                pending_connections_sent: [],
            },
        },
    },
};

export default Connections;
